export default require('mime')
